
import React from 'react'
import {connect} from "react-redux";
import Titulo from "../../framework2/ej2/UI/Titulo";
import "../resources/css/formulario_responsive.css";
import PropTypes from "prop-types";
import {
    COMPONENTE_TIPO_FOREIGN_SERVIDOR,
    CULTURA_COMPONENTE_TIPO_INPUT,
    getValorCampo, guardar,
    setValorCampo,
    showCampo,
    showInput,
    showSeccion, showSecciones
} from "../utils/FormularioUtils";
import {
    COMPONENTE_TIPO_BOOL,
    COMPONENTE_TIPO_DATE,
    COMPONENTE_TIPO_INPUT,
    COMPONENTE_TIPO_MEMO, COMPONENTE_TIPO_SELECT, COMPONENTE_TIPO_FOREIGN,
} from "../utils/FormularioUtils";
import {servicioRestfulMinimo, servidor} from "../Configuracion";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {tiposPagos} from "../utils/Definiciones";



class Tratamientotipo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            elemento: props.elemento,
        }
        this.elementoConfig= props.elementoConfig;
    }

    componentDidMount() {

    }


    aceptar= () => {
        const {elemento} = this.state;
        const {auth, onAceptar} = this.props;

        console.log("elemento: ", elemento);
        console.log("onAceptar: ", onAceptar);

        guardar(elemento, auth.usuarioCodigo, this.elementoConfig, onAceptar);
    }

    cancelar= () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }

    render() {
        const {elemento} = this.state;

        return (
            <>
                <div className="fr_formulario">
                    {showSecciones(elemento, this.elementoConfig.secciones, this)}
                    <button className="fr_boton aceptar" onClick={this.aceptar}>Aceptar</button>
                    <button className="fr_boton cancelar" onClick={this.cancelar}>Cancelar</button>
                </div>
            </>
        )
    }

}

Tratamientotipo.propTypes = {
    elementoConfig: PropTypes.object,
    elemento: PropTypes.object,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    console.log ("mapStateToProps ", state);
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Tratamientotipo);



